const API_STACK = 'auth/';

export const GET_PROFILE = API_STACK + 'profile';
export const POST_PROVIDER = API_STACK + 'providersignup';

export const GET_WHITELIST = API_STACK + 'whitelist';
export const POST_WHITELIST = GET_WHITELIST;
export const DELETE_WHITELIST = GET_WHITELIST + '/:id';